import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence } from "framer-motion";
import { setLenis } from "./components/elevate/data";
import Loader from "./components/elevate/Loader";
import Cursor from "./components/elevate/Cursor";
import Navbar from "./components/elevate/Navbar";
import Hero from "./components/elevate/Hero";
import Intro from "./components/elevate/Intro";
import TwoSides from "./components/elevate/TwoSides";
import Services from "./components/elevate/Services";
import Intelligence from "./components/elevate/Intelligence";
import BengaluruMap from "./components/elevate/BengaluruMap";
import Process from "./components/elevate/Process";
import OffMarket from "./components/elevate/OffMarket";
import { ForLandlords, ForOccupiers } from "./components/elevate/Audiences";
import SocialProof from "./components/elevate/SocialProof";
import CaseStudies from "./components/elevate/CaseStudies";
import Insights from "./components/elevate/Insights";
import FinalCTA from "./components/elevate/FinalCTA";
import Footer from "./components/elevate/Footer";
import WhatsAppFloat from "./components/elevate/WhatsAppFloat";
import EnquiryModals from "./components/elevate/EnquiryModals";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = loading ? "hidden" : "";
    const t = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(t);
  }, [loading]);

  return (
    <div className="grain bg-obsidian font-sans text-ivory" data-testid="app-root">
      <AnimatePresence>{loading && <Loader key="loader" />}</AnimatePresence>
      <Cursor />
      <Navbar ready={!loading} />
      <main>
        <Hero ready={!loading} />
        <Intro />
        <TwoSides />
        <Services />
        <Intelligence />
        <BengaluruMap />
        <Process />
        <OffMarket />
        <ForLandlords />
        <ForOccupiers />
        <SocialProof />
        <CaseStudies />
        <Insights />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
      <EnquiryModals />
    </div>
  );
}

export default App;
